export const CATEGORIES = ["All Projects", "Branding", "Logo Design", "Packaging", "Graphic Design", "Digital Design", "Website Design"];

export const PROJECTS = [
  {
    slug: "modern-brand-identity",
    title: "Modern Brand Identity",
    category: "Branding",
    categories: ["Branding", "Logo Design"],
    image: "identity",
    alt: "Concept brand identity stationery with navy and royal blue papers and a bold wordmark",
    summary: "A confident identity system for a fictional consultancy, built on a heavy wordmark and a disciplined navy palette.",
    brief: "Create a modern identity for an imagined professional services brand that needs to feel established on day one, across print and screen.",
    approach: "We let the wordmark do the work: a tight, heavy logotype paired with generous margins, a single accent colour and a rigid stationery grid.",
    palette: ["#142B4A", "#2457C5", "#C8FF3D", "#F8F7F4"],
    typography: "Geometric grotesque in extra-bold for the mark; a neutral sans for all supporting text.",
    deliverables: ["Wordmark", "Stationery suite", "Colour system", "Brand guidelines"],
  },
  {
    slug: "luxury-packaging-concept",
    title: "Luxury Packaging Concept",
    category: "Packaging",
    categories: ["Packaging"],
    image: "packaging",
    alt: "Concept luxury skincare bottles and boxes in matte navy with lime bands",
    summary: "Matte navy skincare packaging with restrained foil type and a single lime band to signal the range.",
    brief: "Explore how a premium skincare range could stand out on a crowded shelf without relying on gold or excessive ornament.",
    approach: "A soft-touch navy base, minimal typography and a thin colour band that changes per product, keeping the range unified yet easy to navigate.",
    palette: ["#10213A", "#142B4A", "#2457C5", "#C8FF3D"],
    typography: "Wide-tracked uppercase sans for product names; small serif-free details for ingredients.",
    deliverables: ["Bottle labels", "Carton design", "Range system", "Product mockups"],
  },
  {
    slug: "restaurant-branding",
    title: "Restaurant Branding",
    category: "Branding",
    categories: ["Branding", "Graphic Design"],
    image: "restaurant",
    alt: "Concept restaurant brand applied to menus, napkins, plates and a canvas tote",
    summary: "A warm, crafted identity for an imagined coastal restaurant, from menus to takeaway bags.",
    brief: "Design a hospitality identity that feels relaxed and generous while remaining refined enough for evening dining.",
    approach: "An elegant script-led wordmark, hand-drawn botanical details and a blue-and-white palette inspired by glazed tableware.",
    palette: ["#2457C5", "#F8F7F4", "#E9EEF5", "#142B4A"],
    typography: "Expressive script wordmark balanced with a clean sans for menus and signage.",
    deliverables: ["Logo", "Menus", "Table collateral", "Takeaway packaging"],
  },
  {
    slug: "technology-startup-identity",
    title: "Technology Startup Identity",
    category: "Logo Design",
    categories: ["Logo Design", "Branding"],
    image: "tech",
    alt: "Concept geometric tech logo applied to poster, laptop sticker, t-shirt and lanyard",
    summary: "A modular geometric mark for a fictional technology startup, designed to scale from favicon to billboard.",
    brief: "Create a memorable symbol for an early-stage technology company that suggests momentum and connection.",
    approach: "Interlocking hexagonal forms with an upward arrow, built on a strict grid so the mark stays sharp at every size.",
    palette: ["#142B4A", "#2457C5", "#C8FF3D", "#FFFFFF"],
    typography: "Monoline geometric sans with open apertures for digital clarity.",
    deliverables: ["Symbol + wordmark", "App icon", "Merchandise", "Launch assets"],
  },
  {
    slug: "corporate-brochure-design",
    title: "Corporate Brochure Design",
    category: "Graphic Design",
    categories: ["Graphic Design"],
    image: "brochure",
    alt: "Concept corporate brochure spread with blue duotone photography and large headlines",
    summary: "An editorial brochure with duotone imagery and a bold typographic grid.",
    brief: "Design a company profile brochure that feels like a contemporary magazine rather than a sales leaflet.",
    approach: "Large headlines, blue duotone photography and a 12-column grid create rhythm, with lime used only for key facts.",
    palette: ["#2457C5", "#142B4A", "#C8FF3D", "#F8F7F4"],
    typography: "Condensed display headlines with a highly readable text face for long copy.",
    deliverables: ["24-page brochure", "Cover design", "Print-ready files", "Digital PDF"],
  },
  {
    slug: "creative-marketing-campaign",
    title: "Creative Marketing Campaign",
    category: "Graphic Design",
    categories: ["Graphic Design", "Digital Design"],
    image: "campaign",
    alt: "Concept poster campaign with abstract blue and lime typography on a city wall",
    summary: "A loud, typographic poster series designed to stop people in the street and in the feed.",
    brief: "Develop a flexible campaign look that works as large-format posters and as social content.",
    approach: "Abstract letterforms, a two-colour system and a modular grid that can be remixed endlessly for new formats.",
    palette: ["#C8FF3D", "#2457C5", "#142B4A", "#F8F7F4"],
    typography: "Custom-cut abstract letterforms with a supporting heavy grotesque.",
    deliverables: ["Poster series", "Social templates", "Digital ads", "Campaign toolkit"],
  },
  {
    slug: "website-landing-page",
    title: "Website Landing Page",
    category: "Website Design",
    categories: ["Website Design", "Digital Design"],
    image: "website",
    alt: "Concept landing page on a laptop with floating interface components",
    summary: "A conversion-focused landing page with a strong headline system and modular content blocks.",
    brief: "Design a landing page that introduces a service clearly and guides visitors towards one primary action.",
    approach: "A bold hero, clear content hierarchy and reusable section blocks, planned for mobile first and scaled up.",
    palette: ["#142B4A", "#2457C5", "#C8FF3D", "#E9EEF5"],
    typography: "Large editorial headings with a calm, legible interface typeface.",
    deliverables: ["Desktop layouts", "Mobile layouts", "Component library", "Style guide"],
  },
  {
    slug: "mobile-application-interface",
    title: "Mobile Application Interface",
    category: "Digital Design",
    categories: ["Digital Design"],
    image: "mobile",
    alt: "Concept finance app interface shown on three smartphones with navy cards and lime buttons",
    summary: "A calm, data-rich app interface with clear cards, charts and a single bright call to action.",
    brief: "Explore an interface for a personal finance app that makes numbers feel approachable.",
    approach: "Dark navy cards, generous spacing and lime reserved for primary actions, built from a reusable component set.",
    palette: ["#10213A", "#2457C5", "#C8FF3D", "#E9EEF5"],
    typography: "Rounded sans for numerals and a compact UI typeface for labels.",
    deliverables: ["Key screens", "Component set", "Interaction notes", "Prototype"],
  },
];
